import React from "react";
import {Modal, Card, CardContent, CardActions, Divider, Button, Link} from "@material-ui/core";
import {datasetLabel} from "../../../../helpers/datasetLabels";

const CARD_STYLE = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    maxHeight: '100%',
    overflowY: 'auto',
    width: '20%',
};

// A button stretches and centres its text as a flex item, where the anchor this replaces did not.
const LINK_STYLE = {
    alignSelf: 'flex-start',
    textAlign: 'left',
    font: 'inherit',
};

const PersonMatchDialog = (
    {
        open, name, datasets, canImport = true,
        onAccept, onDecline, onPreview, dismissible = false,
    }
) => {
    const datasetsLabel = (datasets || []).map(datasetLabel).join(', ');

    return (
        <Modal open={open} onClose={dismissible ? onDecline : () => {}}>
            <Card style={CARD_STYLE}>
                <CardContent style={{display: 'flex', flexDirection: 'column'}}>
                    <p>This contact is already in the database{datasetsLabel && ` (${datasetsLabel})`}</p>
                    {/* component="button" rather than the default anchor: with no href an <a> is
                        neither focusable nor activatable from the keyboard, and opening the person
                        preview is the one thing in here that is not a dialog button. */}
                    <Link component="button" type="button" style={LINK_STYLE} onClick={onPreview}>{name}</Link>
                    <p>
                        {canImport
                            ? 'Do you want to import its data?'
                            : 'Do you want to link this contact to that person?'}
                    </p>
                </CardContent>
                <Divider/>
                <CardActions style={{justifyContent: 'flex-end'}}>
                    <Button onClick={onDecline}>NO</Button>
                    <Button onClick={onAccept}>YES</Button>
                </CardActions>
            </Card>
        </Modal>
    );
};

export default PersonMatchDialog;
